import gql from 'graphql-tag'
import { get } from 'lodash'
import { apolloClientPrivate } from '../graphql/apolloClient'

export interface IResponse {
  id: number
}

export const PATHWAY_REMOVE_USER_MUTATION = gql`
  mutation pathwayRemoveUser($pathwayId: PositiveInt!, $userId: PositiveInt!) {
    admin {
      pathway(id: $pathwayId) {
        id
        removeUser(id: $userId)
      }
    }
  }
`
// TODO move into a gql file and use the generated query
export default async (
  pathwayId: number,
  userId: number
): Promise<IResponse> => {
  const result = await apolloClientPrivate.mutate<{
    admin: {
      pathway: {
        removeUser: number
      }
    }
  }>({
    variables: {
      pathwayId,
      userId
    },
    mutation: PATHWAY_REMOVE_USER_MUTATION
  })

  return get(result, 'data.admin.pathway.removeUser')
}
